import React, { useState, useContext } from 'react';
import { PageContext } from '../frontend/pageContext';
import {
  getFilterListFromTags,
  externalSearchRedirect,
} from '../frontend/utils';
import ToggleThemeBtn from './shared/ToggleThemeBtn';

interface Props {
  setMobileMenuOpen: (boolean) => void;
}

const Topbar = ({ setMobileMenuOpen }: Props) => {
  const { docSpace, docLeaf, tagSet } = useContext(PageContext);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const filterList = getFilterListFromTags(tagSet, docSpace, docLeaf);

  const submitSearch = () => {
    const searchFilters = filterList.map((tag, i) => {
      const version = [docSpace?.version, docLeaf?.version];
      const versionTag = tag === 'latest' ? 'Latest' : `v${tag}`;
      return version.includes(tag) ? versionTag : tag;
    });
    externalSearchRedirect(searchTerm, searchFilters);
  };

  const handleSearchChange = (e) => setSearchTerm(e.currentTarget.value);

  return (
    <nav className="navbar">
      <div
        className={`search-bar${mobileSearchOpen ? ' is-active' : ''}`}
        data-test-id="mobile-search-bar"
      >
        <input
          className="search-input"
          placeholder="search"
          value={searchTerm}
          type="text"
          onChange={handleSearchChange}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              submitSearch();
            }
          }}
        />
        <input
          className="search-button"
          type="button"
          data-test-id="mobile-search-open"
          onClick={(e) => {
            e.stopPropagation();
            setMobileSearchOpen((searchOpen) => !searchOpen);
          }}
        />
      </div>
      <div
        className="menu-icon"
        data-test-id="mobile-menu-open"
        tabIndex={0}
        onClick={(event) => {
          event.stopPropagation();
          setMobileMenuOpen((isMobileMenuOpen: boolean) => {
            document.body.classList.toggle('menu-open', !isMobileMenuOpen);
            return !isMobileMenuOpen;
          });
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            setMobileMenuOpen((isMobileMenuOpen: boolean) => {
              document.body.classList.toggle('menu-open', !isMobileMenuOpen);
              return !isMobileMenuOpen;
            });
          }
        }}
        role="button"
      ></div>
      <div className="container">
        <a href="/">
          <img
            className="container-logo"
            src="/assets/images/logo-white-footer.png"
            alt="Logo"
          />
        </a>
      </div>
      <div className="toggle-theme-mobile-wrapper">
        <ToggleThemeBtn />
      </div>
    </nav>
  );
};

export default Topbar;
